export class TypePers {

	public nom: string;

	public fonc: string;

	public pren: string;

	public civilite: string;

	constructor() {
		 		this.nom = '';
		this.fonc = '';
		this.pren = '';
		this.civilite = '';

	}
}
